/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesBlockFormats.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Block Format Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, November 14, 2018 - 12:17:52 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      11/14/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const BlockFormatList = Loadable({
    loader: () => import('../containers/BlockFormats/BlockFormatListContainer'),
    loading: Loading,
});

export const BlockFormatForm = Loadable({
    loader: () => import('../containers/BlockFormats/BlockFormatEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesBlockFormats.js